<div class="container" style="padding-bottom: 100px !important;">
    <header>
        <div class="d-flex justify-content-between align-items-center">     
            <h1 class="p-0 headline-4">Auctions</h1>
            <div class="card__right-side d-flex justify-content-end search">
                <div class="search__icon-wrapper">
                  <i class="fas fa-search  input-prefix"></i>
                </div>
                <input [formControl]="search" class="form-control--search" placeholder="Search Auctions…" />
                <div class="search__icon-wrapper--cross px-1"><span class="cursor-pointer" *ngIf="search.value.length > 0" (click)="resetSearch()">X</span></div>
              </div>
        </div>
        <ng-container  *ngIf="auctions.length !== 0">
            <span class="grey-text subtitle-1">You have a total of 
                <b class="black-text">
                    {{totalAuctions}} auctions, 
                    <ng-container *ngIf="activeAuctions">{{activeAuctions}} Active,</ng-container> 
                    <ng-container *ngIf="pausedAuctions"> {{pausedAuctions}} Paused,</ng-container>
                    <ng-container *ngIf="endedAuctions"> {{endedAuctions}} Ended</ng-container>
                </b>
            </span>
        </ng-container>
    </header>
    <div class="py-5 mb-5">
        <span class="body-1" *ngIf="!isShowFilteredAuctions">No matching Auctions</span>    
        <ng-container *ngIf="auctions.length !== 0 && isShowFilteredAuctions">
                <app-auction-card *ngFor="let auction of filteredAuctions" [auction]="auction" [userHandle]="userHandle" style="cursor: pointer;"></app-auction-card>
        </ng-container>
    </div>
</div>

